/**
 * Depends On
 *
 * Hide/show form inputs based on
 * a radio/select input value
 * @since 1.0.0
 */

const DependsOn = () => {
    console.log('I am running')
    const containers = document.querySelectorAll('.js-depends-on')
    if (containers.length < 1) return
        ;
    [...containers].forEach(container => {
        const input_name = container.dataset.name
        const input_value = container.dataset.value
        const form = container.closest('.js-form')
        const leader_inputs = form.querySelectorAll(
            'input[name="' + input_name + '"],select[name="' + input_name + '"]',
        )
        const depender_inputs = container.querySelectorAll(
            'input,textarea,select')
        let current_value = ''

            // disable all inputs inside c-depends-on
        ;[...depender_inputs].forEach(input => {
            input.disabled = true
        })
        ;[...leader_inputs].forEach(input => {
            if (input.checked) {
                // get checked radio button value
                current_value = input.value
            }
            if (input.tagName === 'SELECT') {
                // get selected option value
                current_value = getCurrentOption(input)
            }

            // on first load
            if (current_value == input_value) {
                showDependers(container, depender_inputs)
            }

            // hide/show on click/change
            if (input.tagName !== 'SELECT') {
                // radio button
                input.addEventListener('click', () => {
                    if (input.value == input_value) {
                        showDependers(container, depender_inputs)
                    } else {
                        hideDependers(container, depender_inputs)
                    }
                })
            } else {
                // select
                input.addEventListener('change', () => {
                    current_value = getCurrentOption(input)
                    if (current_value == input_value) {
                        showDependers(container, depender_inputs)
                    } else {
                        hideDependers(container, depender_inputs)
                    }
                })
            }
        }) // end foreach
    }) // end foreach
}

function getCurrentOption (input) {
    return input.options[input.selectedIndex].value
}

function hideDependers (container, depender_inputs) {
    container.classList.remove('active')
    ;[...depender_inputs].forEach(input => {
        input.disabled = true
    })
}

function showDependers (container, depender_inputs) {
    container.classList.add('active')
    ;[...depender_inputs].forEach(input => {
        input.disabled = false
    })
}

export default DependsOn

// WEBPACK FOOTER //
// ./src/js/modules/DependsOn.js
